import {VuexModule, Action, Mutation} from 'vuex-module-decorators';
import {httpClient} from '@/api/baseApi';
import {EntityData} from '@/interfaces/config';

/*
    Динамический модуль хранилища vuex для работы объектами
*/

export class EntityModule extends VuexModule {
  public entities: EntityData[] = [];

  protected routeName!: string;

  get all(): EntityData[] {
    return this.entities;
  }

  @Mutation
  setAll(entities: EntityData[]) {
    this.entities = entities;
  }

  //Получение списка объектов с сервера
  @Action
  public async fetchAll(transformGet: Function, slash = true) {
    try {
      const {data} = await httpClient.get(this.routeName + (slash ? '/' : ''));
      const transformData: EntityData[] = data.map((elem: any) => transformGet(elem));
      this.context.commit('setAll', transformData);
    } catch (e) {
      // TODO: сделать во всех местах обработку ошибок получения данных
      // axios.isAxiosError работает только в новой версии
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      if (e?.request?.status === 403) {
        console.log('Не хватает прав доступа к ', this.routeName);
      } else {
        console.log(e);
      }
      return Promise.reject(e);
    }
  }

  //Получение модели для создания объекта
  @Action
  public async create(transformCreateEdit: Function): Promise<{data: EntityData}> {
    try {
      const {data} = await httpClient.get(`${this.routeName}/create`);
      const transformData = transformCreateEdit(data);
      return {data: transformData};
    } catch (e) {
      return Promise.reject(e);
    }
  }

  //Получение модели для редактирования объекта
  @Action
  public async edit(id: any, transformCreateEdit: Function): Promise<{data: EntityData}> {
    try {
      const {data} = await httpClient.get(`${this.routeName}/${id}`);
      const transformData = transformCreateEdit(data);
      transformData.id = id;
      return {data: transformData};
    } catch (e) {
      return Promise.reject(e);
    }
  }

  //Удаление объекта
  @Action
  public async delete(id: any) {
    try {
      await httpClient.delete(`${this.routeName}/${id}`);
    } catch (e) {
      return Promise.reject(e);
    }
  }

  //Создание/реактирование объекта
  @Action
  public async save(model: EntityData, transformSave: Function, slash = true) {
    try {
      const transformModel = transformSave(model);
      if (model.id) {
        const responce = await httpClient.put(`${this.routeName}/${model.id}`, transformModel);
        return responce.data;
      } else {
        const responce = await httpClient.post(this.routeName + (slash ? '/' : ''), transformModel);
        return responce.data;
      }
    } catch (e) {
      return Promise.reject(e);
    }
  }

  //Получение объекта по идентификатору
  @Action
  public async getById(id: number, transformGetById: Function): Promise<{data: EntityData}> {
    try {
      const {data} = await httpClient.get(`${this.routeName}/${id}`);
      const transformData = transformGetById(data);
      return {data: transformData};
    } catch (e) {
      return Promise.reject(e);
    }
  }
}
